// Single source for location options. Values are the exact CRM picklist options.

// Betenbough Locations (GHL LhPpc9mNBXKyBq1YwTHI): value = CRM option, label = short office name
export const BH_LOCATION_OPTIONS = [
  { value: "Betenbough Amarillo", label: "Amarillo" },
  { value: "Betenbough Lubbock Northwest", label: "Lubbock Northwest" },
  { value: "Betenbough Lubbock South", label: "Lubbock South" },
  { value: "Betenbough Lubbock West", label: "Lubbock West" },
  { value: "Betenbough Midland", label: "Midland" },
  { value: "Betenbough Odessa", label: "Odessa" },
];

export const BH_OFFICES = BH_LOCATION_OPTIONS.map((o) => o.label);

// Credit Firm offices — Location Folder (GHL dNghgKNeip71iQehuuhu)
export const CFI_OFFICE_OPTIONS = [
  "Midland Office 432-599-4880",
  "Odessa Office 432-599-4880",
  "Amarillo Office 806-576-4995",
  "Abilene Office 325-899-3968",
  "San Angelo Office 325-899-3968",
  "Waco Office 254-313-0507",
  "Austin Office 512-439-0649",
  "Tyler Office 903-405-1321",
  "Hobbs Office 575-208-2394",
  "Roswell Office 575-208-1833",
  "Las Cruces Office 575-526-7707",
  "Charlotte Office 704-777-4444",
  "Lubbock Office 806-853-8341",
].map((o) => ({ value: o, label: o }));
